import {
  FINISHED_AREA_OPTIONS,
  LAND_SIZE_OPTIONS,
  YEAR_BUILT_OPTIONS,
  LISTING_STATUS_OPTIONS,
  MAX_PRICE,
  MIN_PRICE,
  MIN_YEAR_BUILT,
  MAX_YEAR_BUILT,
  MIN_LAND_SIZE,
  MAX_LAND_SIZE,
  MIN_FINISHED_AREA,
  MAX_FINISHED_AREA,
  MIN_BEDS,
  MIN_BATHS,
} from '@/components/filters/constants/options';
import { MapZoomLevel } from '@/components/maps/enums';
import { SEARCH_BUILDING_CLASSES } from '@/components/features/search/shared/constants/BuildingClasses';

export const DEFAULT_SEARCH_DATA = {
  minLat: null,
  minLon: null,
  maxLat: null,
  maxLon: null,
  center: null,
  zoom: MapZoomLevel.XSmall,
  sort: 'price_desc',
  beds: MIN_BEDS,
  baths: MIN_BATHS,
  searchAddress: '',
  minPrice: MIN_PRICE,
  maxPrice: MAX_PRICE,
  minYearBuilt: MIN_YEAR_BUILT,
  maxYearBuilt: MAX_YEAR_BUILT,
  minLotSizeAcres: MIN_LAND_SIZE,
  maxLotSizeAcres: MAX_LAND_SIZE,
  minFinishedSqft: MIN_FINISHED_AREA,
  maxFinishedSqft: MAX_FINISHED_AREA,
  listingType: [],
  listingStatus: LISTING_STATUS_OPTIONS,
  buildingClass: SEARCH_BUILDING_CLASSES,
  finishedArea: FINISHED_AREA_OPTIONS,
  landSize: LAND_SIZE_OPTIONS,
  yearBuilt: YEAR_BUILT_OPTIONS,
};

export const EVENT_TRACKING_PARAMS = {
  beds: 'numberBeds',
  baths: 'numberBaths',
  finishedArea: 'sqftValue',
  buildingClass: 'propertyType',
  price: 'price',
  listingType: 'listingType',
  listingStatus: 'listingStatus',
  landSize: 'landSize',
  yearBuilt: 'yearBuilt',
};

export default {
  DEFAULT_SEARCH_DATA,
  EVENT_TRACKING_PARAMS,
};
